import { twMerge } from "tailwind-merge"
import { isMobileOnly } from "react-device-detect"
import clsx from "clsx"

import { defaultBikeFleetQuery } from "../constant"
import { TagsWrapper, ItemLinkTag } from "components/Tags"
import { StatusEnum } from "../types/bikeFleetType"
import { getLabelFromStatusNumber } from "../utils"

const StatusBikeFleet: React.FC = () => {
	return (
		<TagsWrapper
			className={"flex mb-5 "}
			queryParams={{
				default: defaultBikeFleetQuery,
				queryRef: "status",
			}}
		>
			<ItemLinkTag
				dataCy="tabs-in-service-status"
				id={StatusEnum.IN_SERVICE}
				label={getLabelFromStatusNumber(StatusEnum.IN_SERVICE)}
				className={clsx(
					"relative ",
					"after:absolute after:w-0 after:h-[1px] after:bg-secondary after:bottom-0 after:right-0 after:transition-all"
				)}
				containerClassName={clsx("border-r text-center border-primary", {
					"px-6": !isMobileOnly,
					"px-3": isMobileOnly,
				})}
				activeClassName={"text-secondary after:w-full"}
			/>
			<ItemLinkTag
				dataCy="tabs-stolen-status"
				containerClassName={clsx("border-r border-primary text-center", {
					"px-6": !isMobileOnly,
					"px-3": isMobileOnly,
				})}
				id={StatusEnum.STOLEN}
				label={getLabelFromStatusNumber(StatusEnum.STOLEN)}
				className={clsx(
					"relative",
					"after:absolute after:w-0 after:h-[1px] after:bg-secondary after:bottom-0 after:right-0 after:transition-all"
				)}
				activeClassName={"text-secondary after:w-full"}
			/>
			<ItemLinkTag
				dataCy="tabs-all-status"
				id={StatusEnum.ALL}
				label={getLabelFromStatusNumber(StatusEnum.ALL)}
				className={twMerge(
					"relative",
					"after:absolute after:w-0 after:h-[1px] after:bg-secondary after:bottom-0 after:right-0 after:transition-all"
				)}
				containerClassName={clsx("text-center", {
					"px-3": isMobileOnly,
					"px-6": !isMobileOnly,
				})}
				activeClassName={"text-secondary after:w-full"}
			/>
		</TagsWrapper>
	)
}
export default StatusBikeFleet
